import {
  CapacitySeatFill18Icon,
  DropdownDownFill18Icon,
  DropdownUpFill18Icon,
} from "@vygruppen/spor-icon-react";
import EstimatedPassengerSVG from "features/CenterContent/VehicleDetails/TrainDetails/TrainRoute/icons/EstimatedPassanger.svg?react";
import { Count } from "features/CenterContent/VehicleDetails/TrainDetails/TrainRoute/types";
import { useTranslation } from "react-i18next";
import { Text } from "shared/components/Spor";
import styled, { useTheme } from "styled-components";

const FillRateWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 3px;

  & .passenger_count {
    margin-right: 6px;
  }
`;

export const FillRate = ({
  count,
  isVisited,
}: {
  count: Count;
  isVisited: boolean;
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const textColor = isVisited ? theme.colorTextMain : theme.colorTextDisabled;

  return (
    <FillRateWrapper>
      {count.passengerCountStatus === "ACTUAL" ? (
        <>
          <CapacitySeatFill18Icon
            color={textColor}
            title={t("Målt antall passasjerer")}
          />
          <Text
            fontSize="16px"
            color={textColor}
            className="passenger_count"
            title={t("Målt antall passasjerer")}
          >
            {count.passengerCount}
          </Text>
        </>
      ) : (
        <>
          <EstimatedPassengerSVG
            color={textColor}
            title={t("Estimert antall passasjerer")}
          />
          <Text
            fontSize="16px"
            color={textColor}
            className="passenger_count"
            title={t("Estimert antall passasjerer")}
          >
            {count.passengerCount}
          </Text>
        </>
      )}
      <DropdownUpFill18Icon title={t("Påstigning")} color={textColor} />
      <Text fontSize="16px" color={textColor} title={t("Påstigning")}>
        {count.passengersIn}
      </Text>
      <DropdownDownFill18Icon title={t("Avstigning")} color={textColor} />
      <Text fontSize="16px" color={textColor} title={t("Avstigning")}>
        {count.passengersOut}
      </Text>
    </FillRateWrapper>
  );
};
